import React from 'react';

// Matches the bottom sector banner in the Varahi template image
export const SectorBanner = () => (
  <div className="sector-banner">
    <div className="sector-item">
      <span className="sector-x">✕</span>
      <span>Mining</span>
    </div>
    <div className="sector-item">
      <span className="sector-icon">◆</span>
      <span>Diamonds</span>
    </div>
    <div className="sector-item">
      <span className="sector-icon">♻</span>
      <span>Renewables</span>
    </div>
    <div className="sector-item">
      <span className="sector-icon">🌿</span>
      <span>Eco Tourism</span>
    </div>
  </div>
);

// Matches the address line at the very bottom of the template image
export const AddressFooter = () => (
  <div className="address-footer">
    Orbit Building, 5th Floor, AWFIS, Raidurg, Hyderabad, Telangana, India
  </div>
);

// Full site footer for inner pages
export const MainFooter = ({ onNavigate }) => (
  <footer className="main-footer">
    <div className="footer-grid">
      <div className="footer-col">
        <h4>Varahi Global Consulting</h4>
        <p style={{ lineHeight: 1.9, marginBottom: '0.5rem' }}>
          Bridging global expertise with African opportunity across mining,
          diamonds, renewables, and eco-tourism.
        </p>
        <p>info@varahiconsulting.com</p>
        <p>careers@varahiconsulting.com</p>
        <p>operations@varahiconsulting.com</p>
      </div>
      <div className="footer-col">
        <h4>Company</h4>
        <a onClick={() => onNavigate('about')}>About Us</a>
        <a onClick={() => onNavigate('team')}>Our Team</a>
        <a onClick={() => onNavigate('projects')}>Projects</a>
        <a onClick={() => onNavigate('news')}>News & Blog</a>
        <a onClick={() => onNavigate('careers')}>Careers</a>
      </div>
      <div className="footer-col">
        <h4>Sectors</h4>
        <a onClick={() => onNavigate('mining')}>Mining</a>
        <a onClick={() => onNavigate('diamonds')}>Diamonds</a>
        <a onClick={() => onNavigate('renewables')}>Renewables</a>
        <a onClick={() => onNavigate('ecotourism')}>Eco Tourism</a>
        <a onClick={() => onNavigate('africa')}>Africa Operations</a>
      </div>
      <div className="footer-col">
        <h4>Head Office</h4>
        <p>Orbit Building, 5th Floor</p>
        <p>AWFIS, Raidurg</p>
        <p>Hyderabad, Telangana</p>
        <p>India</p>
        <p style={{ marginTop: '0.75rem' }}>Africa Offices:</p>
        <p>Nairobi · Accra · Gaborone</p>
      </div>
    </div>
    <div className="footer-bottom">
      <span>© 2025 Varahi Global Consulting. All rights reserved.</span>
      <span>Mining · Diamonds · Renewables · Eco Tourism</span>
    </div>
  </footer>
);
